import { Upload } from 'lucide-react';
import { useId, useRef, useState, type ReactNode } from 'react';
import './upload.css';

interface Props {
  /** MIME-Typen/Endungen für den Dateidialog (`accept`). */
  accept: string;
  onFiles: (files: File[]) => void;
  multiple?: boolean;
  disabled?: boolean;
  label?: ReactNode;
  hint?: ReactNode;
  testId?: string;
}

/** Ablagefläche für Dateien: Klick/Enter öffnet den Dateidialog, Drag & Drop legt ab. */
export function FileDrop({ accept, onFiles, multiple, disabled, label = 'Datei auswählen oder hierher ziehen', hint, testId = 'file-drop' }: Props) {
  const input = useRef<HTMLInputElement>(null);
  const [over, setOver] = useState(false);
  const hintId = useId();
  const take = (list: FileList | null) => {
    if (!list || list.length === 0 || disabled) return;
    onFiles(multiple ? [...list] : [list[0]!]);
  };
  return (
    <div
      className={`file-drop ${over ? 'over' : ''} ${disabled ? 'disabled' : ''}`}
      onDragOver={(e) => {
        if (disabled) return;
        e.preventDefault();
        setOver(true);
      }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => {
        e.preventDefault();
        setOver(false);
        take(e.dataTransfer.files);
      }}
      data-testid={testId}
    >
      <button type="button" className="btn btn-ghost" onClick={() => input.current?.click()} disabled={disabled} aria-describedby={hint ? hintId : undefined} data-testid={`${testId}-button`}>
        <Upload size={18} aria-hidden="true" />
        {label}
      </button>
      {hint && (
        <span className="field-hint" id={hintId}>
          {hint}
        </span>
      )}
      <input
        ref={input}
        type="file"
        accept={accept}
        multiple={multiple}
        hidden
        onChange={(e) => {
          take(e.target.files);
          e.target.value = '';
        }}
        data-testid={`${testId}-input`}
      />
    </div>
  );
}
